module.exports = __webpack_public_path__ + "img/icon-scene-5.3a72f1fe.png";